import { BusinessConfig } from '../types';

export const SUBSCRIPTION_GRACE_PERIOD_MS = 7 * 24 * 60 * 60 * 1000;
const ALLOWED_SUBSCRIPTION_STATUSES = new Set(['active', 'trialing', 'trial', 'past_due']);
const ONE_DAY_MS = 24 * 60 * 60 * 1000;

export function isSubscriptionAccessible(paymentInfo?: BusinessConfig['paymentInfo']): boolean {
  if (!paymentInfo) {
    return false;
  }

  if (paymentInfo.skipSubscriptionCheck === true) {
    return true;
  }

  const status = paymentInfo.subscriptionStatus ?? '';
  if (ALLOWED_SUBSCRIPTION_STATUSES.has(status)) {
    return true;
  }

  if (typeof paymentInfo.currentPeriodEnd !== 'number') {
    return false;
  }

  return Date.now() < (paymentInfo.currentPeriodEnd + SUBSCRIPTION_GRACE_PERIOD_MS);
}

export function getSubscriptionLockDeadlineMs(paymentInfo?: BusinessConfig['paymentInfo']): number | null {
  if (!paymentInfo || typeof paymentInfo.currentPeriodEnd !== 'number') {
    return null;
  }

  return paymentInfo.currentPeriodEnd + SUBSCRIPTION_GRACE_PERIOD_MS;
}

export function getDaysUntilSubscriptionLock(paymentInfo?: BusinessConfig['paymentInfo']): number | null {
  const deadlineMs = getSubscriptionLockDeadlineMs(paymentInfo);
  if (deadlineMs == null) {
    return null;
  }

  return Math.max(0, Math.ceil((deadlineMs - Date.now()) / ONE_DAY_MS));
}
